import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import { fetchCount } from './counterAPI';

const initialState = {
  sourceApp: "none",
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    updateAppHost(state, action) {
      state.sourceApp = action.payload;
    },
    resetAppHost(state) {
      state.sourceApp = "";
    },
  },
});

export const { updateAppHost, resetAppHost } = appSlice.actions;

export default appSlice.reducer;
